import { makeStyles } from "@fluentui/react-components";
import { $sky60, $white } from "../cssjs/colors";

export const buttonStyles = makeStyles({
  applyButton: {
    color: $sky60,
    borderRadius: "5px",
    border: `1px solid ${$sky60}`,
    ":hover": {
      backgroundColor: $sky60,
      color: $white,
    },
  },
});
